import { apiConfig } from "./apiConfig";

export const templateApi = apiConfig.injectEndpoints({
  endpoints: (builder) => ({
    getTemplateList: builder.query<
      any,
      {
        startKey: string;
        page_size?: number | string;
        firmware?: string | null;
        brand_id: string | null;
        family_id: string | null;
        model_id: string | null;
      }
    >({
      query: ({
        startKey,
        page_size,
        brand_id,
        family_id,
        model_id,
        firmware,
      }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family/${family_id}/model/${model_id}/template`,
        params: {
          start_key: startKey,
          page_size: Number(page_size),
          ...(firmware ? { firmware } : {}),
        },
      }),
      providesTags: ["Template"],
    }),

    createTemplate: builder.mutation<
      any,
      {
        brand_id: string | null;
        family_id: string | null;
        model_id: string | null;
        body: any;
      }
    >({
      query: ({ body, brand_id, family_id, model_id }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family/${family_id}/model/${model_id}/template`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["Template"],
    }),

    getSingleTemplateDetails: builder.query<
      any,
      {
        brand_id: string | null;
        family_id: string | null;
        model_id: string | null;
        template_id: string | null;
      }
    >({
      query: ({ brand_id, family_id, model_id, template_id }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family/${family_id}/model/${model_id}/template/${template_id}`,
      }),
    }),

    editTemplate: builder.mutation<
      any,
      {
        brand_id: string | null;
        family_id: string | null;
        model_id: string | null;
        template_id: string | null;
        body: any;
      }
    >({
      query: ({ brand_id, body, family_id, model_id, template_id }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family/${family_id}/model/${model_id}/template/${template_id}`,
        method: "PUT",
        body: body,
      }),
      invalidatesTags: ["Template"],
    }),
  }),
});

export const {
  useLazyGetTemplateListQuery,
  useCreateTemplateMutation,
  useEditTemplateMutation,
  useLazyGetSingleTemplateDetailsQuery,
} = templateApi;
